module.exports = __webpack_public_path__ + "d7771265296f6219816723049841edf2.svg";